export default "__VITE_ASSET__BmXqxAMk__$_?format=webp__"